
class AppBase {

  constructor(config) {

    if (global.App) {
      throw new Error('Application object already exists!');
    }

    // save global reference for appp
    global.App = this;
  }

}

export default AppBase;



// WEBPACK FOOTER //
// ./app/react/AppBase.jsx